import React, { useState, useEffect } from "react";
import axios from "axios";
import { useToast } from "../components/ToastContext";
import Utils from "../utils/utils";
import EditAssignment from "../components/AdminAssignmentFolder/EditAssignment";
import AssignmentDetails from "../components/AdminAssignmentFolder/AssignmentDetails";
import Drawer from "../components/Drawer";
import CreateAssignment from "../components/AdminAssignmentFolder/CreateAssignment";
import AdminAssignmentCard from "../components/AdminAssignmentFolder/AdminAssignmentCard";

const Assignments = () => {
  const token = Utils.getToken();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const showToast = useToast();
  const [assignments, setAssignments] = useState([]);
  const [renderAssignment, setRenderAssignment] = useState(false);

  const FetchAssignments = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/assignments/`, {
        method: "GET",
        mode: "cors",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setAssignments(response.data.data);
      } else {
        showToast(response.statusText, "error", true, 5000);
        return;
      }
    } catch (error) {
      console.log("Catch => " + error.message);
      showToast(error.message, "error", true, 5000);
    }
  };

  useEffect(() => {
    FetchAssignments();
    setRenderAssignment(true);
  }, []);

  const [drawerState, setDrawerState] = useState({
    isOpen: false,
    Component: null,
    componentProps: {},
  });

  const openDrawer = (Component, componentProps = {}) => {
    setDrawerState({
      isOpen: true,
      Component,
      componentProps,
    });
  };

  const handleEditAssignment = (item, index) => {
    openDrawer(EditAssignment, {
      item,
      index,
      onClose: closeDrawer,
      setAssignments,
    });
  };

  const handleOpenAssignment = (item) => {
    openDrawer(AssignmentDetails, { item, closeDrawer });
  };

  const closeDrawer = () => {
    setDrawerState({ isOpen: false, Component: null, componentProps: {} });
  };
  return (
    <div className="shadow-none p-4 overflow-y-auto overflow-x-hidden space-y-4 h-[calc(100vh-65px)]">
      <div className="flex justify-between">
        <div className="w-56">
          {Utils.UserRole && Utils.UserRole.toLowerCase() === "admin" && (
            <CreateAssignment props={{ setAssignments, assignments }} />
          )}
        </div>
      </div>
      {/* ================Assignments Rendering here================== */}
      <div
        className={`w-full transition-transform duration-700 ease-in-out transform ${
          renderAssignment
            ? "translate-x-0 opacity-100"
            : "translate-x-[-100%] opacity-0"
        }`}
        key={"AdminAssignmentsContainer"}
      >
        {assignments.map((item, index) => (
          <AdminAssignmentCard
            item={item}
            index={index}
            onEdit={() => handleEditAssignment(item, index)}
            onView={() => handleOpenAssignment(item)}
            onClose={() => closeDrawer}
            setAssignments={setAssignments}
          />
        ))}
      </div>

      <Drawer props={{ ...drawerState, closeFn: closeDrawer }} />
    </div>
  );
};

export default Assignments;
